module.exports = __webpack_public_path__ + "3d6316eb72abe6df0f6bd1f71f9327d4.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/3l mayorista.png
// module id = 583
// module chunks = 0